import device from '@/utils/device';
import H5 from './h5';
import PC from './pc';

export default device.isMobile ? H5 : PC;
